module.exports = __webpack_public_path__ + "static/img/student-download-bg.7b5354a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/download/student-download-bg.png
// module id = VJQ4
// module chunks = 2